import {Component, attr} from "../Component";
import {element} from "../CustomElement";
import {i18n} from "../../i18n/I18n";

import {Link, ButtonLink} from "../flipp-link/Link";
import {Page} from "../flipp-page/Page";

import {inject} from "../../services/di";
import {ConfigService} from "../../services/ConfigService";

@element("flipp-error-page")
export class ErrorPage extends Component<{page: boolean, isWatchList: string}, {}> {

	@inject config: ConfigService;
	@attr page: boolean;
	@attr isWatchList: string;

	render() {
		if (this.isWatchList === "true") {
			return this.renderWatchListPage();
		}
		const contents = <div class="flipp-404" flex-vertical>
				<h1>{i18n("missing_page_title")}</h1>
				<p class="apology-msg">{i18n("missing_page_apology_msg")}</p>
				<img src="https://f.wishabi.net/creative/Distribution/images/errors/error-page-bg.svg" alt="clean up on aisle 404 image"/>
				<p class="cto-msg">{i18n("missing_page_cta_msg")}</p>
				<img src="https://f.wishabi.net/creative/Distribution/images/errors/error-page-dropped-can.svg" alt="single dropped can image"/>
				<Link to="listing">{i18n("missing_page_cta_button")}</Link>
			</div>;
		if (this.page) {
			return <Page show="flyers">{contents}</Page>;
		}
		return contents;
	}

	renderWatchListPage() {
		return (
			<Page show="flyers">
				<div class="flipp-404" flex-vertical>
					<h1>{i18n("watchlist_title")}</h1>
					<p class="apology-msg">{i18n("watchlist_headline")}</p>
					<img src="https://f.wishabi.net/creative/Distribution/images/errors/error-page-bg.svg" alt="watchlist image"/>
					<a href="https://flipp.app.link/bP4IhdBh7ab">
						{i18n("watchlist_button")}
					</a>
				</div>
			</Page>
		);
	}
}
